import styled, { css } from 'styled-components';

export const StyledCell = styled.div<{
  flex?: number;
  padding?: number | string;
  textAlign?: string;
  width?: number | string;
  emptyValue?: string;
  debug?: boolean;
  displayMode?: 'flex' | 'table';
  noCellWrap?: boolean;
}>`
  flex: ${({ flex }) => flex};
  padding: ${({ padding = 12 }) => typeof padding === 'number' ? `${padding}px` : padding};
  text-align: ${({ textAlign }) => textAlign || 'center'};
  font-size: 14px;
  word-break: break-word;
  box-sizing: border-box;
  display: ${({ displayMode }) => displayMode === 'table' ? 'table-cell' : 'block'};

  ${({ noCellWrap }) => noCellWrap && css`
    white-space: nowrap;
  `}

  ${({ width }) => width && css`
    min-width: ${typeof width === 'number' ? `${width}px` : width};
    max-width: ${typeof width === 'number' ? `${width}px` : width};
  `}

  ${({ emptyValue }) => emptyValue && css`
    &:empty {
      &:before {
        content: '${emptyValue}';
      }
    }
  `}

  ${({ debug }) => debug && css`
    outline: 1px solid green;
  `}
`;
